// extracted by mini-css-extract-plugin
export default {"parties":"Parties_parties__UdGHK"};